<rt-basic-multi-select
  [control]="control()"
  [selectOptions]="userOptions()"
  [isInvalid]="isInvalid()"
  [isReadOnly]="isReadOnly()"
  [hasExtendedPreview]="true"
/>
